import { render, staticRenderFns } from "./OnlineQuestion.vue?vue&type=template&id=cd6309e4&scoped=true&"
import script from "./OnlineQuestion.vue?vue&type=script&lang=js&"
export * from "./OnlineQuestion.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=cd6309e4&scoped=true&lang=css&"
import style1 from "./OnlineQuestion.vue?vue&type=style&index=1&id=cd6309e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6309e4",
  null
  
)

export default component.exports